import { MenuItem } from "primereact/menuitem";
import CarrierMappingSnapshot from "../model/CarrierData";
import MappingDataAPI from "../services/MappingDataAPI";
import { CarrierDataViewHeaderModel } from "../model/CarrierDataViewModel";
import CustomerDataSnapshot from "../model/CustomerDataSnapshot";
import LookupService from "../../Services/LookupService";
import { SelectOption } from "../../shared/components/input";
import TransactionSummary from "../model/TransactionSummary";
import CustomerTransactionSummary from "../model/CustomerTransactionSummary";
import { promises } from "dns";
import { PolicyDtoRead } from "../../customer/model/PolicyDtoRead";
import { PolicyProcessStatus } from "../model/PolicyProcessStatus";
import { AxiosResponse } from "axios";
import { CustomerSearch } from "../model/CustomerSearch";
import AtmsCustomers from "../model/AtmsCustomers";
import CommonDataService from "../../Services/CommonDataService";
import { CommonUtility } from "../../Services/CommonUtility";
import { PolicyDto } from "../../customer/model/PolicyDto";
import { ApplyTransactionDto, ApplyShellTransactionDto } from "../model/ApplyTransactionDto";
import { TransactionResultItem } from "../model/TransactionResultItem";
import TransactionFilter from "../model/TransactionFilter";


// Displays "{agencyName} {contract_Number}" when agencyName is present, otherwise just contract_Number
export const getAgentCodeDisplay = (contractNumber?: string | null, agencyName?: string | null) => {
    if (contractNumber === undefined || contractNumber === null || contractNumber === "") {
        return '';
    }
    if (agencyName === undefined || agencyName === null || agencyName === "") {
        return contractNumber;
    }
    return `${agencyName} ${contractNumber}`.trim();
}


class PolicyMappingDataService{
 mappingDataAPI :MappingDataAPI= new MappingDataAPI();

   fetchCarrierListByTransactionType = async (transactionType : string) : Promise<CarrierMappingSnapshot[]> => {
       
          let carrierList = await this.mappingDataAPI.getCarrierListByTransactionType(transactionType);
          return carrierList;
      }
    fetchCarrierDataWithCount=async (searchFilter : TransactionFilter) : Promise<CarrierDataViewHeaderModel[]> => {
        let carrierList = await this.mappingDataAPI.getCarrierListwithCount(searchFilter);
        return carrierList;
    }
    fetchCustomerDataSnapshotByCarrierName=async (carrierName:string) : Promise<CustomerDataSnapshot[]> => {
        let customerList = await this.mappingDataAPI.getCustomerDataByCarrierName(carrierName);
        return customerList;
    }
    fetchCustomerDataByCarrierandTransactionCode=async (searchFilter : TransactionFilter) : Promise<AxiosResponse<CustomerDataSnapshot[]>> => {
        let customerList = await this.mappingDataAPI.getCustomerDataByCarrierandTransactionCode(searchFilter);
        return customerList;
    }
    fetchTransactionSummaryByPolicyId=async (policyId:string) : Promise<TransactionSummary> => {
        let customerSummary = await this.mappingDataAPI.getTransactionSummaryByPolicyId(policyId);
        return customerSummary;
    }

    fetchTransactionSummaryList=async (customerFilter: CustomerSearch) : Promise<AxiosResponse<CustomerTransactionSummary[]>> => {
        let customerTransactionList = await this.mappingDataAPI.getTransactionSummaryList(customerFilter);
        return customerTransactionList;
    }
    fetchPolicySumarryByCustomerId= async(customerIds : string[]):Promise<PolicyDtoRead[]>=>{
        let policyTransactionList = await this.mappingDataAPI.getPolicySummary(customerIds);
        return policyTransactionList;
    }

    getTransactionTypes=async () : Promise<SelectOption[]> => {
        let transactionTypes = await LookupService.fetchTransactionTypes();
        return transactionTypes.map(transactionType => ({
                    label: transactionType.lookupValue,
                    value: transactionType.lookupCode,
                    isInactive: transactionType.inactive === 1 ? true : false
                  }));
    }

    applyPolicyTransaction = async (transactionSummary: TransactionSummary, customerId: string, sourceId: string, sourceType: string, cs2PolicyId: string, cs2PriorPolicyId: string, cs2CustomerNumber: number, parentCompanyId: string, writtingCompanyId: string, policyDto: PolicyDto): Promise<string> => {
        let policy = await this.mappingDataAPI.applyPolicyTransaction(transactionSummary, customerId, sourceId, sourceType, cs2PolicyId, cs2PriorPolicyId, cs2CustomerNumber, parentCompanyId, writtingCompanyId, policyDto);
        return policy;
    }

    applyMultiTransaction = async (transactions: ApplyTransactionDto[]): Promise<TransactionResultItem[]> => {
        let result = await this.mappingDataAPI.applyMultiTransaction(transactions);
        return result;
    }

    applyShellPolicyTransaction = async (dto: ApplyShellTransactionDto): Promise<string> => {
        let result = await this.mappingDataAPI.applyShellPolicyTransaction(dto);
        return result;
    }

    updateProcessStatus = async (policyProcessStatus : PolicyProcessStatus): Promise<string> => {
        let response = await this.mappingDataAPI.updateProcessStatus(policyProcessStatus);
        return response;
    }

    getSourceTypes= async () : Promise<SelectOption[]> => {
        let sourceTypes = await LookupService.fetchSourceType();
        return sourceTypes.map(sourceType => ({
                    label: sourceType.lookupValue,
                    value: sourceType.id,
                    isInactive: sourceType.inactive === 1 ? true : false
                  }));
    }

    getAgencies = async () => {
        let agencyList = await LookupService.fetchAgencies();
        return agencyList ? agencyList.map(item => {
            return {
                label: item.lookupValue,
                value: item.id,
                isInactive: false
            }
        }) : [];
    }

    createCustomerAndApply = async (policyId: string, agencyId: string, sourceType: string, sourceId: string, transactionType: string, lineOfBusiness : string, parentComapnyId: string, writtingCompanyId: string): Promise<string> => {
        let response = await this.mappingDataAPI.createCustomerAndApplyPolicyTransaction(policyId, agencyId, sourceType, sourceId, transactionType, lineOfBusiness, parentComapnyId, writtingCompanyId);
        return response;
    }

    createCustomerFromAtmsAndApplyTransaction = async (policyId: string, leadId: string , transactionType: string, lineOfBusiness : string): Promise<string> => {
        let response = await this.mappingDataAPI.createCustomerFromAtmsAndApplyPolicyTransaction(policyId, leadId, transactionType,lineOfBusiness);
        return response;
    }

    getSourceTypeLookupValue = async (sourceTypeId: string): Promise<any> => {
        let sourceTypeTableId = await LookupService.fetchSourceTypeId(sourceTypeId);
        return (Array.isArray(sourceTypeTableId) && sourceTypeTableId.length > 0) ? sourceTypeTableId[0] : {};
    }

    getSourceList = async (sourceType: string): Promise<any> => {
        let sourceList = await this.mappingDataAPI.getSourceList(sourceType);
         return sourceList ? sourceList.map(item => {
            return {
                label: item.sourceName,
                value: item.id,
                isInactive:item.isActive
            }
        }) : [];
    }

    fetchAtsmsCustomerList=async (customerFilter: CustomerSearch) : Promise<AxiosResponse<AtmsCustomers[]>> => {
    let customerTransactionList = await this.mappingDataAPI.getAtmsCustomerList(customerFilter);
    return customerTransactionList;
    }

    fetchCompanyData = async () => {
        let companyList = await CommonDataService.getCompanyList();
        return {
            companyListLookup: CommonUtility.mapCommonDataDtoToSelectOptions(companyList.filter(item => item.flag === true)),
            writingCompaniesLookup: companyList ? companyList.map(item => ({
                label: CommonUtility.capitalizeFirstCharOfEachWord(item.description),
                value: item.id,
                isInactive: false,
                parentId: item.parentCompanyId
            })) : []
        };
    }

    fetchUsStates = async () => {
        const states = await LookupService.fetchUSStates();
        return states ? states.map(item => {
            return {
                label: item.lookupValue,
                value: item.lookupCode,
                isInactive: false
            }
        }) : [];
    }
}




export default PolicyMappingDataService;